import { orchestrator } from 'satcheljs';
import {
    createNewCalendarPublishingPermission,
    setCreatePublishingPermissionPending,
} from '../actions/calendarPublishing';
import { createCalendarPublishingPermission } from '../utils/CalendarPublishingUtils';

export default orchestrator(createNewCalendarPublishingPermission, async msg => {
    setCreatePublishingPermissionPending(true);
    await createCalendarPublishingPermission(msg.folderId, msg.detailLevel);
    setCreatePublishingPermissionPending(false);
});
